import { render, staticRenderFns } from "./infoFilterDetails.vue?vue&type=template&id=71e581aa"
import script from "./infoFilterDetails.vue?vue&type=script&lang=ts"
export * from "./infoFilterDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports